import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { BrokerageProfileForm } from '@/components/Drawers/BrokerageProfileDrawer/BrokerageProfileForm';

export const PrimaryBrokerageSettings = () => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails, isLoading: isLoadingUser } = useGetUserDetailsQuery(
		{ email },
		{ skip: !email },
	);

	if (isLoadingUser && !userDetails) {
		return (
			<Box display='flex' justifyContent='center' py={4}>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<Box
			sx={{
				height: '100%',
				minHeight: 0,
				display: 'flex',
				flexDirection: 'column',
				overflow: 'hidden',
			}}
		>
			<BrokerageProfileForm docId={userDetails?.brokerId} />
		</Box>
	);
};

export default PrimaryBrokerageSettings;
